import type { CompanyState } from './interfaces';

export const initialState: CompanyState = {
  loading: false,
  data: null,
} satisfies CompanyState as CompanyState;
